import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import { StatCard } from "./resellerUi";

const LicenseSold = ({ licenseSold }) => {

  function handleClick() {
    window.sessionStorage.setItem("selectedTab", "License Management");
    window.location.href = "/reseller/licenses";
  };

  return (
    <StatCard icon={VerifiedOutlinedIcon} label="Licenses" value={licenseSold ?? 0} onClick={handleClick} />
  );
};

export default LicenseSold;
